if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        // Check if this has the class .mobile to manage the mobile recipient form
        this.validator = new Validator(this)
        this.mobileDrawer = this.closest('variant-drawer')
        this.isMobile = this.classList.contains('mobile');
        const checkboxSuffix = this.isMobile ? '-mobile' : '-desktop';
        this.recipientFieldsSummary = document.querySelector(`.recipient-fields-summary${checkboxSuffix}`);
        this.validateDataBtn = this.querySelector(`#gift-card-review${checkboxSuffix}`);
        this.editDataBtn = document.querySelector(`#edit-gift${checkboxSuffix}`);
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
        this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}${checkboxSuffix}`);
        this.checkboxInput.disabled = false;
        this.emailId= `#Recipient-email-${this.dataset.sectionId}`
        this.dateId  = `#Recipient-send-on-${this.dataset.sectionId}`
        this.emailInput = this.querySelector(`${this.emailId} input`);
        this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
        this.messageInputMaxCharsLabel = this.querySelector(`#Recipient-message-max-chars-label-${this.dataset.sectionId} > span`);
        this.messageInputMaxChars = this.messageInput.maxLength; // 200
        this.maxCharsStringLength = this.messageInputMaxChars.toString().length;
        this.sendonInput = this.querySelector(`${this.dateId} input`);
        this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();
        this.recipientFields = this.querySelector('.recipient-fields');
        this.addEventListener('change', this.onChange.bind(this));
        this.messageInput.addEventListener('input', this.onMessageInput.bind(this));
        this.sendonInput.addEventListener('input', this.onSendonInput.bind(this));
        this.validateDataBtn.addEventListener('click', this.onValidateData.bind(this));
        this.editDataBtn?.addEventListener('click', this.onEditData.bind(this));
        this.checkboxInput.addEventListener('change', this.onCheckboxChange.bind(this));
        this.onChange();
        this.checkboxTrigger = document.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}-trigger`);
      }

      cartUpdateUnsubscriber = undefined;

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe('cart-update', (event) => {
          if (event.source === 'product-form') {
            this.resetRecipientForm();
          }
        });

      }

      onChange() {
        if (this.checkboxInput.checked) {
          this.enableInputFields();
          this.makeInputFieldsEditable();
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.validateDataBtn.classList.remove('data-validated');
          this.sendonInput.classList.add('no-value'); // Shows the placeholder from the date input
          this.recipientFields.style = '';
          this.recipientFieldsSummary?.classList.add('hidden');
        }
      }

      onCheckboxChange() {
        if (this.isMobile) {
          if (!this.checkboxInput.checked) {
            this.classList.add('hide')
            this.mobileDrawer.close()
          }
          const customTriggerEvent = new CustomEvent('customChange');
          this.checkboxTrigger.dispatchEvent(customTriggerEvent);
        }
      }

      onValidateData() {

        const validMail = this.validator.validateEmail(this.emailInput.value);
        const validDate = this.validateDate(this.sendonInput.value);

        if (!validMail) {
          this.validator.addError(this.emailId, 'Email invalid');
        } else {
          this.validator.removeError(this.emailId);
        }

        if (validDate.error) {
          this.validator.addError(this.dateId, validDate.message);
        } else {
          this.validator.removeError(this.dateId);
        }

        if (validMail && !validDate.error ) {
          this.makeInputFieldsReadOnly();
          this.validateDataBtn.classList.add('data-validated');
          this.createFieldsSummary();
          if (this.isMobile) {
            this.classList.add('hide')
            this.mobileDrawer.close()
          }
        }
      }

      validateDate(date) {
        if (date === '') return true;
        const inputDate = new Date(date);
        const currentDate = new Date();
        const maxAllowedDate = new Date();
        maxAllowedDate.setUTCMonth(maxAllowedDate.getUTCMonth() + 3);
        if (Object.prototype.toString.call(inputDate) === "[object Date]" && !isNaN(inputDate) && inputDate > currentDate) {
          if (inputDate <= maxAllowedDate) {
            return {
              error: false
            }
          } else {
            return {
              error: true,
              message: "Send on must be within 90 days from now"
            }
          }
        }

        return {
          error: true,
          message: "Send on must be in the future"
        }

      }
      createFieldsSummary() {
        // Display only the filled fields
        const summaryList = this.recipientFieldsSummary.querySelector('.summary-list');
        summaryList.innerHTML = ''; // Clear the summary list
        // Check each field value and add it to the summary list if not empty
        if (this.emailInput.value !== '') {
          const emailSummary = document.createElement("li");
          emailSummary.textContent = "Email: " + this.emailInput.value;
          summaryList.appendChild(emailSummary);
        }
        if (this.nameInput.value !== '') {
          const nameSummary = document.createElement("li");
          nameSummary.textContent = "Name: " + this.nameInput.value;
          summaryList.appendChild(nameSummary);
        }
        if (this.messageInput.value !== '') {
          const messageSummary = document.createElement("li");
          messageSummary.textContent = "Message: " + this.messageInput.value;
          summaryList.appendChild(messageSummary);
        }
        if (this.sendonInput.value !== '') {
          const sendonSummary = document.createElement("li");
          sendonSummary.textContent = "Send on: " + this.sendonInput.value;
          summaryList.appendChild(sendonSummary);
        }
        this.recipientFields.style = 'display: none;';
        this.recipientFieldsSummary.classList.remove('hidden');
      }
      onEditData() {
        this.recipientFieldsSummary?.classList.add('hidden');
        this.recipientFields.style = '';
        this.makeInputFieldsEditable();
        if (this.isMobile) {
          this.classList.remove('hide')
          this.mobileDrawer.open()
        }
        this.validateDataBtn.classList.remove('data-validated');
      }

      onMessageInput() {
        const inputString = this.messageInput.value.length;
        const remainingChars = this.messageInputMaxChars - inputString;
        const maxCharsLabelTextContent = this.messageInputMaxCharsLabel.textContent;
        this.messageInputMaxCharsLabel.textContent = remainingChars + maxCharsLabelTextContent.substring(this.maxCharsStringLength);
        if (remainingChars < 10) this.maxCharsStringLength = 1;
        else if (remainingChars < 100) this.maxCharsStringLength = 2;
        else if (remainingChars < 1000) this.maxCharsStringLength = 3;
      }
      onSendonInput() {
        // If the date input is not empty, hide the placeholder
        if (this.sendonInput.value !== '') {
          this.sendonInput.classList.remove('no-value'); // Hides the placeholder from the date input
        } else {
          this.sendonInput.classList.add('no-value'); // Shows the placeholder from the date input
        }
      }
      inputFields() {
        return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
      }
      inputIds() {
        return [this.emailId, this.dateId];
      }
      disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
      }
      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ''));
        this.inputIds().forEach(id => this.validator.removeError(id))
      }
      enableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = false));
      }
      disableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = true));
      }
      makeInputFieldsReadOnly() {
        this.disableableFields().forEach((field) => (field.readOnly = true));
      }
      makeInputFieldsEditable() {
        this.disableableFields().forEach((field) => (field.readOnly = false));
      }


      resetRecipientForm() {
        if (this.checkboxInput.checked) {
          this.checkboxInput.checked = false;
          this.clearInputFields();
          this.onEditData();
        }
      }
    }
  );

  class RecipientFormTrigger extends HTMLElement {
    constructor() {
      super();
      this.checkboxTrigger = this.querySelector('input[type="checkbox"]');
      this.checkboxTrigger.disabled = false;
      this.form = document.querySelector('.recipient-form.mobile');
    }
  
    connectedCallback() {
      this.checkboxTrigger.addEventListener('change', () => {
        if (this.form) {
          this.form.classList.remove('hide')
          this.form.querySelector('input[type="checkbox"]').checked = this.checkboxTrigger.checked;
          this.form.querySelector('input[type="checkbox"]').dispatchEvent(new Event('change'));
          this.form.dispatchEvent(new Event('change'));
        }
      });

      this.checkboxTrigger.addEventListener('customChange', () => {
        this.checkboxTrigger.checked = this.form.querySelector('input[type="checkbox"]').checked;
      });
    }
  }
  
  customElements.define('recipient-form-trigger', RecipientFormTrigger);
}

